/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var ContinuousChaosConfigStatus;
(function (ContinuousChaosConfigStatus) {
    ContinuousChaosConfigStatus["deleted"] = "deleted";
    ContinuousChaosConfigStatus["disabled"] = "disabled";
    ContinuousChaosConfigStatus["enabled"] = "enabled";
})(ContinuousChaosConfigStatus || (ContinuousChaosConfigStatus = {}));
export var FaultCategory;
(function (FaultCategory) {
    FaultCategory["application_layer"] = "application_layer";
    FaultCategory["aws"] = "aws";
    FaultCategory["az_failover"] = "az_failover";
    FaultCategory["blackhole"] = "blackhole";
    FaultCategory["network"] = "network";
    FaultCategory["stress"] = "stress";
})(FaultCategory || (FaultCategory = {}));
export var Permission;
(function (Permission) {
    Permission["Admin"] = "Admin";
    Permission["Read"] = "Read";
    Permission["Write"] = "Write";
})(Permission || (Permission = {}));
export var PremiseProvider;
(function (PremiseProvider) {
    PremiseProvider["perfhammer"] = "perfhammer";
})(PremiseProvider || (PremiseProvider = {}));
export var PremiseType;
(function (PremiseType) {
    PremiseType["perfhammer_apis"] = "perfhammer_apis";
    PremiseType["perfhammer_scripts"] = "perfhammer_scripts";
    PremiseType["perfhammer_sqs"] = "perfhammer_sqs";
})(PremiseType || (PremiseType = {}));
export var ProbeAction;
(function (ProbeAction) {
    ProbeAction["alb_metrics"] = "alb_metrics";
    ProbeAction["signalfx_query"] = "signalfx_query";
})(ProbeAction || (ProbeAction = {}));
export var ProbeCategory;
(function (ProbeCategory) {
    ProbeCategory["cloudwatch"] = "cloudwatch";
    ProbeCategory["signalfx"] = "signalfx";
})(ProbeCategory || (ProbeCategory = {}));
export var ResilienceFaults;
(function (ResilienceFaults) {
    ResilienceFaults["aws_resource_blackhole"] = "aws_resource_blackhole";
    ResilienceFaults["az_failure"] = "az_failure";
    ResilienceFaults["compute_az_failover"] = "compute_az_failover";
    ResilienceFaults["connection_reset_by_peer"] = "connection_reset_by_peer";
    ResilienceFaults["custom_response"] = "custom_response";
    ResilienceFaults["custom_status_code"] = "custom_status_code";
    ResilienceFaults["dns_blackhole"] = "dns_blackhole";
    ResilienceFaults["empty_response"] = "empty_response";
    ResilienceFaults["fixed_delay"] = "fixed_delay";
    ResilienceFaults["generic_service_blackhole"] = "generic_service_blackhole";
    ResilienceFaults["malformed_response_chunk"] = "malformed_response_chunk";
    ResilienceFaults["network_delay"] = "network_delay";
    ResilienceFaults["network_delay_v2"] = "network_delay_v2";
    ResilienceFaults["packet_corruption"] = "packet_corruption";
    ResilienceFaults["packet_drop"] = "packet_drop";
    ResilienceFaults["packet_duplication"] = "packet_duplication";
    ResilienceFaults["random_data_then_close"] = "random_data_then_close";
    ResilienceFaults["rds_az_failover"] = "rds_az_failover";
    ResilienceFaults["reboot_rds"] = "reboot_rds";
    ResilienceFaults["redis_az_failover"] = "redis_az_failover";
    ResilienceFaults["stress_cpu"] = "stress_cpu";
    ResilienceFaults["stress_disk"] = "stress_disk";
    ResilienceFaults["stress_io"] = "stress_io";
    ResilienceFaults["stress_memory"] = "stress_memory";
    ResilienceFaults["terminate_instances"] = "terminate_instances";
})(ResilienceFaults || (ResilienceFaults = {}));
export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["disabled"] = "disabled";
    ScheduleStatus["finished"] = "finished";
    ScheduleStatus["paused"] = "paused";
    ScheduleStatus["scheduled"] = "scheduled";
    ScheduleStatus["skipped"] = "skipped";
})(ScheduleStatus || (ScheduleStatus = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["none"] = "none";
    ScheduleType["once"] = "once";
    ScheduleType["recurring"] = "recurring";
})(ScheduleType || (ScheduleType = {}));
export var TaskExecutionMode;
(function (TaskExecutionMode) {
    TaskExecutionMode["parallel"] = "parallel";
    TaskExecutionMode["sequential"] = "sequential";
})(TaskExecutionMode || (TaskExecutionMode = {}));
export var WargameCategory;
(function (WargameCategory) {
    WargameCategory["cronos"] = "cronos";
    WargameCategory["default"] = "default";
    WargameCategory["dynamic"] = "dynamic";
    WargameCategory["userdefined"] = "userdefined";
})(WargameCategory || (WargameCategory = {}));
export var WargameTemplatePublishStatus;
(function (WargameTemplatePublishStatus) {
    WargameTemplatePublishStatus["disabled"] = "disabled";
    WargameTemplatePublishStatus["draft"] = "draft";
    WargameTemplatePublishStatus["published"] = "published";
})(WargameTemplatePublishStatus || (WargameTemplatePublishStatus = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
